import styles from './BeeAutoLanding.module.css'
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import ButtonContainer from "../../../FormTemplate/ButtonContainer/ButtonContainer";
import React, {useEffect, useRef, useState} from "react";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import LoggerItem, {ILoggerItem} from "../../../FormTemplate/LoggerItem/LoggerItem";
import InputItemLight, {IRefInputItemLight} from "../../../FormTemplate/InputItemLight/InputItemLight";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import useLongTask from "../../../Util/LongTaskItem/UseLongTask";

interface ILandingData
{
    orderId: string
    ban:string
    mode: number

    useAddress?:IAddressItem
    usePlace?:string
    useTarif?:string

    srcCity?:string

    gender:string
    from?:string
    type:number


}



interface IBeeAutoLandingProps
{
    onClose: ()=>void
    ctn:string
    tmpCtn:string
    orderId:string


}

interface IAddressItem
{
    city: string
    street: string
    home: string
    room: string
}

export default function BeeAutoLanding({tmpCtn, ctn,onClose,orderId}:IBeeAutoLandingProps){
    const refState = useRef<ErrorLineItemRef>(null)
    const refLogger = useRef<ILoggerItem>(null)
    const [gender, setGender] = useState("M")
    const [useOrderAddress, setUseOrderAddress] = useState(true)
    const [useOrderPlace, setUseOrderPlace] = useState(true)
    const [useOrderTarif, setUseOrderTarif] = useState(true)



    const dataContract = useRef<{
        orderId:string
        city:string
        birthPlace?:string
        tarifId?:string
        gender:string
        address?:IAddressItem
        type:number

    }>()
    const [ldrContract,rsContract,exContract] = useApiQuery("/doc/beeline/template/contract","post",dataContract);



    const [rayId, setRayId]  = useState(null)

    const dataLanding = useRef<ILandingData>()
    const [ldrLanding,rsLanding,exLanding] = useApiQuery("/beelanding/make","post",dataLanding);

    const [ldrCheckTask, exCheckTask] = useLongTask(100,2000, (state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),(state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),true)


    const [work, setWork] = useState(false)
    const [type, setType] = useState(0)


    const [address, setAddress] = useState<IAddressItem>({
        city: "Новосибирск",
        street: "Титова",
        home: "10",
        room: "15"
    })

    const [place, setPlace]= useState("Новосибирск")
    const [srcCity, setSrcCity]= useState("Новосибирск")
    const [tarif, setTarif]= useState("X")

    const [ban, setBan]= useState("-")

    const [from , setFrom] = useState("МТС")


    const refCity = useRef<IRefInputItemLight>(null)
    const refStreet = useRef<IRefInputItemLight>(null)
    const refHome = useRef<IRefInputItemLight>(null)
    const refRoom = useRef<IRefInputItemLight>(null)

    const refBan = useRef<IRefInputItemLight>(null)
    const refPlace = useRef<IRefInputItemLight>(null)
    const refTarif = useRef<IRefInputItemLight>(null)
    const refFrom = useRef<IRefInputItemLight>(null)
    const refSrcCity = useRef<IRefInputItemLight>(null)


    useEffect(()=>{
        if(rayId)   {
            exCheckTask(rayId)
            setWork(true)

        }


    },[rayId])


    const onResultTaskTick = (state: boolean, data:any , code:number ,cnt: number)=>{
        console.log("task", state, data, code, cnt)
        if(state) setWork(false)
        if(refLogger.current)refLogger.current.log(data)

    }



    const buildGenderItem = ()=>{
        return(
            <div className={styles.gCont}>
                <div className={styles.gTitle}>Пол</div>
                <div className={styles.gLine}>
                    <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={gender === "M"} onChange={()=>setGender("M")}/>
                    <div className={styles.adTitle}>М</div>
                </div>
                <div className={styles.gLine}>
                    <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={gender === "F"} onChange={()=>setGender("F")}/>
                    <div className={styles.adTitle}>Ж</div>
                </div>
            </div>
        )
    }
    const buildTypeItem = ()=>{
        return(
            <div className={styles.gCont}>
                <div className={styles.gTitle}>Тип заказа</div>
                <div className={styles.gLine}>
                    <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={type===0} onChange={()=>setType(0)}/>
                    <div className={styles.adTitle}>Постоплата</div>
                </div>
                <div className={styles.gLine}>
                    <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={type===1} onChange={()=>setType(1)}/>
                    <div className={styles.adTitle}>Предоплата</div>
                </div>
            </div>
        )
    }

    const buildPlaceItem = ()=>{
        return (
            <div className={["row my-1"].join(' ')}>
                <div className={"d-flex col-lg-6 col-sm-12"}>
                    <div className={styles.ncCont}>
                        <div className={styles.adLine}>
                            <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={useOrderPlace} onChange={()=>setUseOrderPlace(! useOrderPlace)}/>
                            <div className={styles.adTitle}>Использовать место рождения из заказа</div>
                        </div>
                    </div>
                </div>

                {!useOrderPlace &&
                    <div className={"d-flex col-lg-6 col-sm-12"}>
                        <InputItemLight
                            val={place ? place : "-"}
                            title={"Место рождения"}
                            titleColNumber={4}
                            ref={refPlace}
                            mode={"e"}
                            regExp={/^[а-я-0-9\/\s]{2,}$/ui}
                            canEmpty={false}
                            onChange={(e)=>{
                                setPlace(e)
                            }}
                        />
                    </div>
                }
            </div>
        )
    }

    const buildTarifItem = ()=>{
        return (
            <div className={["row my-1"].join(' ')}>
                <div className={"d-flex col-lg-6 col-sm-12"}>
                    <div className={styles.ncCont}>
                        <div className={styles.adLine}>
                            <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={useOrderTarif} onChange={()=>setUseOrderTarif(! useOrderTarif)}/>
                            <div className={styles.adTitle}>Использовать тариф из заказа</div>
                        </div>
                    </div>
                </div>

                {!useOrderTarif &&
                    <div className={"d-flex col-lg-6 col-sm-12"}>
                        <InputItemLight
                            val={tarif ? tarif : "-"}
                            title={"Код тарифа"}
                            titleColNumber={4}
                            ref={refTarif}


                            mode={"e"}
                            regExp={/^[a-z\w\W]{2,}$/ui}
                            canEmpty={false}
                            onChange={(e)=>{
                                setTarif(e)
                            }}
                        />
                    </div>
                }
            </div>
        )
    }

    const buildBanItem = () =>{
        return(
            <div className={["row my-1"].join(' ')}>
                <div className={"d-flex col-lg-6 col-sm-12"}>
                    <InputItemLight
                        val={ban ? ban : "0000000000"}
                        title={"Бан подключения"}
                        titleColNumber={5}
                        maxLen={9}
                        ref={refBan}
                        mode={"e"}
                        regExp={/^[0-9]{9}$/ui}
                        canEmpty={false}
                        onChange={(e)=>{
                            setBan(e)
                        }}
                    />
                </div>
                <div className={"d-flex col-lg-6 col-sm-12"}>
                    <InputItemLight
                        val={srcCity ? srcCity : "-"}
                        title={"Город договора"}
                        titleColNumber={5}
                        ref={refSrcCity}
                        mode={"e"}
                        regExp={/^[\w\W\s]{2,}$/ui}
                        canEmpty={false}
                        onChange={(e)=>{
                            setSrcCity(e)
                        }}
                    />
                </div>

            </div>
        )
    }
    const buildFromItem = () =>{
        return(
            <div className={["row my-1"].join(' ')}>
                <div className={"d-flex col-lg-12 col-sm-12"}>
                    <InputItemLight
                        val={from ? from : "-"}
                        title={"Оператор донор"}
                        titleColNumber={3}
                        maxLen={9}
                        ref={refFrom}
                        mode={"e"}
                        regExp={/^[\w\W\s]{2,}$/ui}
                        canEmpty={false}
                        onChange={(e)=>{
                            setFrom(e)
                        }}
                    />
                </div>
            </div>
        )
    }

    const buildAddressItem = () =>{
        return(
            <div className={styles.adCont}>
                <div className={styles.ncCont}>
                    <div className={styles.adLine}>
                        <input className={["form-check-input"].join(' ')} type={"checkbox"} checked={useOrderAddress} onChange={()=>setUseOrderAddress(! useOrderAddress)}/>
                        <div className={styles.adTitle}>Использовать адрес из заказа</div>
                    </div>
                </div>
                {!useOrderAddress &&
                    <>
                        <div className={["row", styles.iItem].join(' ')}>
                            <div className={"d-flex col-lg-6 col-sm-12"}>
                                <InputItemLight
                                    val={address?.city?.length ? address?.city : "-"}
                                    title={"Город"}
                                    titleColNumber={4}
                                    ref={refCity}

                                    mode={"e"}
                                    regExp={/^[а-я-0-9\/\s]{2,}$/ui}
                                    canEmpty={false}
                                    onChange={(e)=>{
                                        setAddress({...address,city: e})
                                    }}
                                />
                            </div>
                            <div className={"d-flex col-lg-6 col-sm-12"}>
                                <InputItemLight
                                    titleColNumber={4}
                                    title={"Улица"}
                                    ref={refStreet}

                                    val={address?.street?.length ? address?.street : "-"}
                                    mode={"e"}
                                    regExp={/^[а-я-0-9\/\s]{2,}$/ui}
                                    canEmpty={false}
                                    onChange={(e)=>{
                                        setAddress({...address,street: e})
                                    }}
                                />
                            </div>

                        </div>
                        <div className={["row", styles.iItem].join(' ')}>
                            <div className={"d-flex col-lg-6 col-sm-12"}>
                                <InputItemLight
                                    val={address?.home?.length ? address?.home : "-"}
                                    titleColNumber={4}
                                    title={"Дом"}
                                    ref={refHome}

                                    mode={"e"}
                                    regExp={/^[а-я-0-9\/\s]+$/ui}
                                    canEmpty={false}
                                    onChange={(e)=>{
                                        setAddress({...address,home: e})
                                    }}
                                />
                            </div>
                            <div className={"d-flex col-lg-6 col-sm-12"}>
                                <InputItemLight
                                    title={"Квартира"}
                                    titleColNumber={4}
                                    val={address?.room?.length ? address?.room : "-"}
                                    mode={"e"}
                                    ref={refRoom}

                                    regExp={/^[а-я-0-9\/\s]+$/ui}
                                    canEmpty={false}
                                    onChange={(e)=>{
                                        setAddress({...address,room: e})
                                    }}
                                />
                            </div>

                        </div>
                    </>

                }
            </div>
        )
    }

    const validateAddress = ()=>{
        if(!refState.current) return false

        if(useOrderAddress) return true
        if(!refCity.current || !refCity.current.validate()){
            if(refState.current)refState.current.show("Адрес : Город не корректен", true, 0)
            return false
        }
        if(!refStreet.current || !refStreet.current.validate()){
            if(refState.current)refState.current.show("Адрес : Улица не корректна", true, 0)
            return false
        }
        if(!refHome.current || !refHome.current.validate()){
            if(refState.current)refState.current.show("Адрес : Дом не корректен", true, 0)
            return false
        }
        if(!refRoom.current || !refRoom.current.validate()){
            if(refState.current)refState.current.show("Адрес : Квартира не корректна", true, 0)
            return false
        }
        return true


    }
    const validateTarif = ()=>{
        if(!refState.current) return false

        if(useOrderTarif) return true
        if(!refTarif.current || !refTarif.current.validate()){
            if(refState.current)refState.current.show("Тариф не корректен", true, 0)
            return false
        }
        return true


    }

    const validatePlace = ()=>{
        if(!refState.current) return false

        if(useOrderPlace) return true
        if(!refPlace.current || !refPlace.current.validate()){
            if(refState.current)refState.current.show("Место рождения не корректно", true, 0)
            return false
        }
        return true


    }

    const validateBan = ()=>{
        if(!refState.current) return false

        if(!refBan.current || !refBan.current.validate()){
            if(refState.current)refState.current.show("Целевой бан не корректен", true, 0)
            return false
        }
        return true


    }
    const validateSrcCity = ()=>{
        if(!refState.current) return false

        if(!refSrcCity.current || !refSrcCity.current.validate()){
            if(refState.current)refState.current.show("Не корректен город договора", true, 0)
            return false
        }
        return true


    }
    const validateFrom = ()=>{
        if(!refState.current) return false

        if(!refFrom.current || !refFrom.current.validate()){
            if(refState.current)refState.current.show("Оператор донор не корректен", true, 0)
            return false
        }
        return true


    }



    const handleNew = ()=>{
        if(!refState.current || !refLogger.current) return

        refState.current.clear()
        refLogger.current.clear()

        if(! validateBan()) return
        if(! validatePlace()) return
        if(! validateTarif()) return
        if(! validateAddress()) return
        if(! validateSrcCity()) return


        dataLanding.current = {
            orderId: orderId,
            mode: 0,
            ban: ban,
            gender: gender,

            useAddress: !useOrderAddress ? address : undefined,
            usePlace: !useOrderPlace ? place : undefined,
            useTarif: !useOrderTarif ? tarif : undefined,
            srcCity: srcCity,
            type: type,


        }

        console.log(dataLanding?.current)
        refLogger.current.log(["Отправка запроса"])

        exLanding().then((e)=>{
            if(e?.success){
                setRayId(e?.payload?.rayId)
                if(refState.current)refState.current.show("Задача запущена", false, 0)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 0)

        })







    }
    const handleMnp = ()=>{
        if(!refState.current || !refLogger.current) return

        refState.current.clear()
        refLogger.current.clear()

        if(! validateBan()) return
        if(! validatePlace()) return
        if(! validateTarif()) return
        if(! validateAddress()) return
        if(! validateFrom()) return
        if(! validateSrcCity()) return


        dataLanding.current = {
            orderId: orderId,
            mode: 1,
            ban: ban,
            gender: gender,

            useAddress: !useOrderAddress ? address : undefined,
            usePlace: !useOrderPlace ? place : undefined,
            useTarif: !useOrderTarif ? tarif : undefined,
            from: from,
            srcCity: srcCity,
            type: type,

        }

        console.log(dataLanding?.current)
        refLogger.current.log(["Отправка запроса"])

        exLanding().then((e)=>{
            if(e?.success){
                setRayId(e?.payload?.rayId)
                if(refState.current)refState.current.show("Задача запущена", false, 0)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 0)

        })







    }

    const handleDoc = ()=>{
        dataContract.current = {
            orderId: orderId,
            gender: gender,
            city: srcCity,
            type: type,


            birthPlace: !useOrderPlace ? place : undefined,
            tarifId: !useOrderTarif ? tarif : undefined,

            address: !useOrderAddress ? address : undefined,



        }

        exContract().then((e)=>{
            if(e?.success){
                try {
                    e?.payload.blob().then((blob: any) => {
                        const fileURL = window.URL.createObjectURL(blob);
                        let alink = document.createElement("a");
                        alink.href = fileURL;
                        alink.download = "SamplePDF.pdf";
                        alink.click();
                    })

                } catch (e) {
                    console.log(e)
                }
                return

            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,4000)

        })

        console.log("data", dataContract.current)

    }


    const handleMove = ()=>{
        if(!refState.current || !refLogger.current) return

        refState.current.clear()
        refLogger.current.clear()

        if(! validateBan()) return
        if(! validatePlace()) return
        if(! validateTarif()) return
//        if(! validateAddress()) return


        dataLanding.current = {
            orderId: orderId,
            mode: 2,
            ban: ban,
            gender: gender,

            useAddress: !useOrderAddress ? address : undefined,
            usePlace: !useOrderPlace ? place : undefined,
            useTarif: !useOrderTarif ? tarif : undefined,
            from: from,
            type: type,

        }

        console.log(dataLanding?.current)
        refLogger.current.log(["Отправка запроса"])

        exLanding().then((e)=>{
            if(e?.success){
                setRayId(e?.payload?.rayId)
                if(refState.current)refState.current.show("Задача запущена", false, 0)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 0)

        })







    }

    return(
       <ModalWindow>
           <MainFormTemplate title={`Лэндинг [ ${orderId} ] Номер [ ${ctn} ] Временный [ ${tmpCtn} ]`} maxWidth={"1000px"} background={"white"} load={work || ldrLanding}>
               {buildTypeItem()}
               {buildBanItem()}
               {buildFromItem()}
               {buildTarifItem()}
               {buildPlaceItem()}
               {buildAddressItem()}

               <div className={"row "}>
                   {buildGenderItem()}
               </div>

               <div className={"row"}>
                   <div className={"d-flex col-12"}>
                    <LoggerItem lineCount={5} title={"Лог"} ref={refLogger}/>
                   </div>
               </div>
               <div className={"row my-2"}>
                   <ErrorLineItem ref={refState} height={"30px"}/>
               </div>


               <div className={"row my-2"}>
                   <div className={"d-flex col-12"}>
                       <ButtonContainer clsCont={styles.btnCont}>

                           <button type="button" className="btn btn-secondary "
                            disabled={work}
                                   onClick={handleNew}
                           >Новый номер</button>

                           <button type="button" className="btn btn-secondary "
                                   disabled={ tmpCtn?.length < 10 || work}
                                   onClick={handleMnp}
                           >MNP</button>
                           <button type="button" className="btn btn-secondary "
                                   disabled={ ctn?.length < 10 || work}
                                   onClick={handleMove}
                           >Смена тарифа</button>

                           <button type="button" className={["btn btn-secondary ", styles.redButton].join(' ')}
                                   disabled={work}
                                   onClick={handleDoc}
                           >Договор</button>

                           <button type="button" className="btn btn-secondary "
                                   onClick={onClose}
                           >Выход</button>


                       </ButtonContainer>

                   </div>

              </div>
           </MainFormTemplate>
       </ModalWindow>
    )

}